
import * as handlebars_family from "../handlebars_family.ts";
import "../nc/layout.mustache";
import "../widget/download-link.mustache";
const TPL = handlebars_family.addTemplate("nc/password_reset_success",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <h1>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"fw3.passwordreset.success",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":32},"end":{"line":1,"column":70}}})) != null ? stack1 : "")
    + "</h1> "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"widget/download-link"),depth0,{"name":"widget/download-link","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(((helper = (helper = lookupProperty(helpers,"$splash") || (depth0 != null ? lookupProperty(depth0,"$splash") : depth0)) != null ? helper : container.hooks.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),{"name":"$splash","hash":{},"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":11}}}) : helper)))
    + " "
    + ((stack1 = container.invokePartial(lookupProperty(partials,"nc/layout"),depth0,{"name":"nc/layout","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + " ";
},"usePartial":true,"useData":true});
export default TPL;